export default {
  data() {
    return {
      routeName: ''
    }
  },
  props: ['list'],
  mounted() {
    this.routeName = this.$route.name
  },
  methods: {
    routeTo: function (item) {
      if (!item.link) return
      this.$router.push({
        path: item.link,
        query: item.query || {}
      })
    }
  }
}
